var _g, _g2, _g3, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Award_leaderboard_rank_ranking",
    "data-name": "Award, leaderboard, rank, ranking",
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.907,
    height: 57.52,
    viewBox: "0 0 59.907 57.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3794",
    "data-name": "Rectangle 3794",
    transform: "translate(20.54 32.7)",
    fill: "#f8b510",
    stroke: "#f8b510",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H16.828a2,2,0,0,1,2,2V24.82a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16.828,
    height: 22.82,
    rx: 1,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3795",
    "data-name": "Rectangle 3795",
    transform: "translate(0 38.692)",
    fill: "none",
    stroke: "#f8b510",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H16.828a2,2,0,0,1,2,2V18.828a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16.828,
    height: 16.828,
    rx: 1,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_3796",
    "data-name": "Rectangle 3796",
    transform: "translate(41.079 44.281)",
    fill: "none",
    stroke: "#f8b510",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2,0H16.828a2,2,0,0,1,2,2V13.238a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V2A2,2,0,0,1,2,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16.828,
    height: 11.238,
    rx: 1,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17587",
    "data-name": "Path 17587",
    d: "M56.409,15.7a1.733,1.733,0,0,0-1.392-1.19l-5.868-.863-2.6-5.311a1.726,1.726,0,0,0-1.58-.974h0a1.74,1.74,0,0,0-1.559.967L40.8,13.617l-5.854.835a1.747,1.747,0,0,0-1.392,1.183,1.726,1.726,0,0,0,.432,1.782l4.225,4.176-1.016,5.826a1.74,1.74,0,0,0,2.52,1.838l5.262-2.77L50.2,29.271a1.7,1.7,0,0,0,.814.2,1.733,1.733,0,0,0,1.712-2.025l-.981-5.833L55.991,17.5A1.747,1.747,0,0,0,56.409,15.7Z",
    transform: "translate(-14.772 -7.36)",
    fill: "#f8b510"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.b5d2d6130b28f4e5b9882ac672843492.svg";
export { ForwardRef as ReactComponent };